import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { CartProvider, CartDrawer, CartContent } from '../../shared/cart-widget';
import { redirectTo } from '../../shared/navigation';
import { useAppSelector } from '../../app/store';
import { config } from '../../core/config';
import { PublicLayout } from './components';
import { freshPlatformToken as getPlatformCartToken } from '../../core/auth/platformToken';
export { getPlatformCartToken };
const signIn = () => redirectTo('/login');
export function PlatformCartProvider({ children }: { children: ReactNode }) {
  const { i18n } = useTranslation();
  const identity = useAppSelector(({ session }) => `${session.status}:${session.profile.id}:${session.activeOrganizationId ?? ''}`);
  return <CartProvider key={identity} api={config.apiBaseUrl} getToken={getPlatformCartToken} onSignIn={signIn} language={i18n.language}>{children}<CartDrawer /></CartProvider>;
}
export function PlatformCartPage() { return <PublicLayout><section className="hub-wrap" style={{ maxWidth: 760, paddingTop: 32 }}><h1>Shporta</h1><CartContent /></section></PublicLayout>; }
